<template>
  <span :class="coloreLocale(locale)" class="badge-locale">
    {{ nome }}
  </span>
</template>

<script>
export default {
  name: 'badge-locale',
  props: ['locale'],
  computed: {
    nome() {
      return this.descrLocale(this.locale)[0];
    },
  },
};
</script>

<style lang="stylus" scoped>
.badge-locale
  min-width 24px
  min-height 24px
  text-align center
  line-height 24px
  border-radius 4px
  display inline-block
  color white
</style>
